import React, { useCallback, useRef, useState } from 'react';
import { ChevronsLeftRight } from 'lucide-react';

export const BeforeAfterSlider = ({ before, after, title, caption, testId }) => {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);
  const update = useCallback((clientX) => {
    const r = ref.current?.getBoundingClientRect(); if (!r) return;
    setPos(Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100)));
  }, []);
  const onPointerDown = (e) => { dragging.current = true; ref.current?.setPointerCapture?.(e.pointerId); update(e.clientX); };
  const onPointerMove = (e) => { if (dragging.current) update(e.clientX); };
  const onPointerUp = () => { dragging.current = false; };
  const onKey = (e) => { if (e.key === 'ArrowLeft') setPos(p => Math.max(0, p - 5)); if (e.key === 'ArrowRight') setPos(p => Math.min(100, p + 5)); };
  return (
    <figure className="select-none" data-testid={testId}>
      <div ref={ref} onPointerDown={onPointerDown} onPointerMove={onPointerMove} onPointerUp={onPointerUp} onPointerCancel={onPointerUp}
        className="relative aspect-[6/5] md:aspect-[3/2] rounded-2xl overflow-hidden max-w-3xl mx-auto border-2 border-zinc-700 bg-zinc-900 touch-none cursor-ew-resize">
        <img src={after} alt={`${title} after`} loading="lazy" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
        <img src={before} alt={`${title} before`} loading="lazy" className="absolute inset-0 w-full h-full object-cover" draggable={false} style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} />
        <span className="absolute top-3 left-3 text-[10px] font-extrabold uppercase tracking-wider bg-black/80 text-white px-2.5 py-1 rounded-md" style={{ fontFamily: 'Outfit, sans-serif' }}>Before</span>
        <span className="absolute top-3 right-3 text-[10px] font-extrabold uppercase tracking-wider bg-black/80 text-white px-2.5 py-1 rounded-md" style={{ fontFamily: 'Outfit, sans-serif' }}>Guru Standard</span>
        <div className="absolute inset-y-0 w-0.5 bg-white/90" style={{ left: `${pos}%` }} aria-hidden />
        <button type="button" role="slider" aria-label={`${title} before and after comparison`} aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(pos)} onKeyDown={onKey}
          className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-11 h-11 rounded-full bg-black border-2 border-white flex items-center justify-center text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F56F05]" style={{ left: `${pos}%` }}>
          <ChevronsLeftRight className="w-5 h-5" />
        </button>
      </div>
      <figcaption className="mt-4 text-center">
        <p className="gg-display text-2xl text-white">{title}</p>
        {caption && <p className="text-sm font-medium text-zinc-300 mt-1">{caption}</p>}
      </figcaption>
    </figure>
  );
};
